import React from "react"

import { RoomRemarkInput } from "./inputs/RoomRemarkInput"

export const RoomFormRemarkTab = React.memo(() => {
  return (
    <div className="room-form-remark-tab room-form__tab-content">
      <RoomRemarkInput />
    </div>
  )
})
